module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "chat-panel"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPanelEmoji && !_vm.showPanelCommands && !_vm.showPanelGiphy && !_vm.themeSelectorEnabled && !_vm.publicGroupsSelected),
      expression: "!showPanelEmoji && !showPanelCommands && !showPanelGiphy && !themeSelectorEnabled && !publicGroupsSelected"
    }, {
      name: "images-loaded",
      rawName: "v-images-loaded",
      value: (_vm.scrollDownMessages),
      expression: "scrollDownMessages"
    }],
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-messages"
    }
  }, [(_vm.fetchingMessages) ? _c('loader-large') : _vm._e(), _vm._v(" "), (!_vm.fetchingMessages) ? _c('ul', {
    attrs: {
      "id": "chat-messages-list"
    }
  }, _vm._l((_vm.chatMessages), function(message) {
    return _c('li', {
      key: message.type === 'group' ? message.messages[0].id : message.id,
      staticClass: "message"
    }, [(message.type !== 'group' && message.posterId !== 0) ? _c('a', {
      attrs: {
        "href": ("/Profile/" + (message.posterStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(message)
      }
    })]) : _vm._e(), _vm._v(" "), (message.type === 'group') ? _c('a', {
      attrs: {
        "href": ("/Profile/" + (message.messages[0].posterStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(message.messages[0])
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-details"
    }, [(message.type !== 'group' && message.posterId !== 0) ? [_c('span', {
      staticClass: "message-header"
    }, [(message.posterId !== _vm.ownId) ? _c('span', {
      staticClass: "alias",
      on: {
        "click": function($event) {
          return _vm.tagUser(message.posterAlias)
        }
      }
    }, [_vm._v(_vm._s(message.posterAlias))]) : _vm._e(), _vm._v(" "), (message.posterId === _vm.ownId) ? _c('span', {
      staticClass: "alias"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (message.posterId !== _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('i', {
      class: ['fa fa-arrow-up up', {
        highlighted: message.loggedVoteValue === 1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserUp(message.posterId)
        }
      }
    }), _vm._v(" "), _c('i', {
      class: ['fa fa-arrow-down down', {
        highlighted: message.loggedVoteValue === -1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserDown(message.posterId)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.voteValue))]), _vm._v(" "), (!message.isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.posterId)
        }
      }
    }, [_vm._v("Ignore")]) : _vm._e(), _vm._v(" "), (message.isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.posterId)
        }
      }
    }, [_vm._v("Un-Ignore")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (message.posterId === _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.voteValue))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bubble"
    }, [(!message.isIgnored && message.voteValue > _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": message.message
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "timestamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))])], 1) : _vm._e(), _vm._v(" "), (message.isIgnored || message.voteValue <= _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": "*::::Blocked Messages::::*"
      }
    })], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), (message.type === 'group') ? [_c('span', {
      staticClass: "message-header"
    }, [(message.messages[0].posterId !== _vm.ownId) ? _c('span', {
      staticClass: "alias",
      on: {
        "click": function($event) {
          return _vm.tagUser(message.messages[0].posterAlias)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(message.messages[0].posterAlias) + "\n                              ")]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId === _vm.ownId) ? _c('span', {
      staticClass: "alias"
    }, [_vm._v("You")]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId !== _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('i', {
      class: ['fa fa-arrow-up up', {
        highlighted: message.messages[0].loggedVoteValue === 1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserUp(message.messages[0].posterId)
        }
      }
    }), _vm._v(" "), _c('i', {
      class: ['fa fa-arrow-down down', {
        highlighted: message.messages[0].loggedVoteValue === -1
      }],
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.voteUserDown(message.messages[0].posterId)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.messages[0].voteValue))]), _vm._v(" "), (!message.messages[0].isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.messages[0].posterId)
        }
      }
    }, [_vm._v("Ignore")]) : _vm._e(), _vm._v(" "), (message.messages[0].isIgnored) ? _c('span', {
      staticClass: "ignore",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.ignoreUser(message.messages[0].posterId)
        }
      }
    }, [_vm._v("Un-Ignore")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (message.messages[0].posterId === _vm.ownId) ? _c('span', {
      staticClass: "rating"
    }, [_c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(message.messages[0].voteValue))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "bubble"
    }, [_vm._l((message.messages), function(singleMessage) {
      return (!message.messages[0].isIgnored && message.messages[0].voteValue > _vm.userVoteThreshold) ? _c('span', {
        staticClass: "individual-message"
      }, [_c('markdown-content', {
        staticClass: "individual-message-content",
        attrs: {
          "content": singleMessage.message
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "timestamp"
      }, [_vm._v(_vm._s(_vm._f("formatDate")(singleMessage.timestamp)))])], 1) : _vm._e()
    }), _vm._v(" "), (message.messages[0].isIgnored || message.messages[0].voteValue <= _vm.userVoteThreshold) ? _c('span', {
      staticClass: "individual-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": "*::::Blocked Messages::::*"
      }
    })], 1) : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (message.posterId === 0) ? [_c('div', {
      staticClass: "bubble"
    }, [_c('span', {
      staticClass: "individual-message system-message"
    }, [_c('markdown-content', {
      staticClass: "individual-message-content",
      attrs: {
        "content": message.message
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "timestamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))])], 1)])] : _vm._e()], 2)])
  }), 0) : _vm._e()], 1), _vm._v(" "), (_vm.themeSelectorEnabled) ? _c('theme-selector', {
    on: {
      "exitThemeSelectMode": _vm.exitThemeSelectMode
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPanelEmoji) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-help-emoji"
    }
  }, _vm._l((_vm.emojiList), function(emoji) {
    return _c('div', {
      staticClass: "emoji",
      attrs: {
        "title": emoji.alias
      },
      on: {
        "click": function($event) {
          return _vm.addEmoji(emoji.emoji)
        }
      }
    }, [_vm._v("\n      " + _vm._s(emoji.emoji) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showPanelCommands) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-help-commands"
    }
  }, [_c('h1', [_vm._v("Chat Commands")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.showPanelGiphy) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-giphy-panel"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "results-list"
  }, [(_vm.giphySearching) ? _c('loader-large') : _vm._e(), _vm._v(" "), _vm._l((_vm.giphyResults), function(giphyResult) {
    return (!_vm.giphySearching) ? _c('div', {
      staticClass: "result-container",
      on: {
        "click": function($event) {
          return _vm.addGiphyToChat(giphyResult.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": giphyResult.images.fixed_height.url
      }
    })]) : _vm._e()
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.giphySearch),
      expression: "giphySearch"
    }],
    ref: "giphyInput",
    attrs: {
      "type": "text",
      "placeholder": "Search for a Gif..."
    },
    domProps: {
      "value": (_vm.giphySearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.giphySearch = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.publicGroupsSelected) ? _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-public-groups-list"
    }
  }, [_c('h1', [_vm._v("Public Groups")]), _vm._v(" "), (_vm.publicGroupList.length === 0) ? _c('div', {
    staticClass: "validation"
  }, [_vm._v("There are no public groups that you haven't\n      joined\n    ")]) : _vm._e(), _vm._v(" "), (_vm.publicGroupList.length > 0) ? _c('ul', _vm._l((_vm.publicGroupList), function(publicGroup) {
    return _c('li', [_c('button', {
      attrs: {
        "disabled": _vm.joiningPublicGroup
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.joinPublicGroup(publicGroup.id)
        }
      }
    }, [_vm._v("Join Group\n        ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(publicGroup.memberCount) + " Member"), (publicGroup.memberCount !== 1) ? [_vm._v("s")] : _vm._e()], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(publicGroup.alias))])])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('section', {
    class: [{
      'dark': _vm.isDarkMode
    }],
    attrs: {
      "id": "chat-inputs"
    }
  }, [_c('form', {
    attrs: {
      "id": "chat-input"
    }
  }, [_c('div', {
    staticClass: "chat-options"
  }, [_c('i', {
    class: ['fa', 'fa-question-circle-o', 'option-help', {
      selected: _vm.showPanelCommands
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCommandsPanel($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-smile-o', 'option-emoji', {
      selected: _vm.showPanelEmoji
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleEmojiPanel($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'option-gif', {
      selected: _vm.showPanelGiphy
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleGiphyPanel($event)
      }
    }
  }, [_vm._v("gif")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "attach-file",
      "name": "attach-file",
      "type": "file"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), (!_vm.isUploading) ? _c('label', {
    attrs: {
      "for": "attach-file"
    }
  }, [_c('i', {
    staticClass: "fa fa-paperclip option-attach"
  })]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-dashboard', 'option-theme', {
      selected: _vm.themeSelectorEnabled
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleThemeSelector($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    class: ['fa', 'fa-users', 'option-public-groups', {
      selected: _vm.publicGroupsSelected
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.togglePublicGroups($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chat-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    ref: "inputChatBox",
    attrs: {
      "type": "text",
      "placeholder": "Type Here...",
      "maxlength": "600"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitMessage($event)
      }
    }
  }, [_vm._v("Send")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("some *text* example")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Italicizes text: some "), _c('em', [_vm._v("text")]), _vm._v(" example")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("some **text** example")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Bolds text: some "), _c('strong', [_vm._v("text")]), _vm._v(" example")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/me mesage")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Sends an action message")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/flip or /flipcoin")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Flips a coin and gives the result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/roll")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Rolls a Six-Sided Dice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "command-entry"
  }, [_c('span', {
    staticClass: "command"
  }, [_vm._v("/roll XdY")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Rolls X Y-Sided Dice. Example: "), _c('em', [_vm._v("/roll 4d10")]), _vm._v(" rolls 4 10 sided dice.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-giphy"
  }, [_c('img', {
    attrs: {
      "src": "/static/powered-by-giphy.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298d30b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ChatRoom/ChatPanel.vue
// module id = 394
// module chunks = 1